var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ordinal = require('ordinal');
var indicator = require('ordinal/indicator');
var stable = require('stable');
var slugify = require('../utils/slugify.js');

function CompanyCard(el) {
  var $el = $(el),
      $ticker = $el.attr('data-company-ticker'),
      $sort = $el.attr('data-sort'),
      $companyData = '/wp-content/themes/justcapital/assets/data/companies.json',
      $companies;

  $.getJSON($companyData, function(data) {
    $companies = data;
    data.forEach(function(company) {
      if (company.ticker === $ticker) showCompany(company);
    });
  });

  function showCompany(company) {
    var $rank = parseInt(company.rank.overall),
        $ordinalRank = $rank ? $rank + '<span>' + indicator($rank) + '</span>' : '<span>Not displayed</span>';
        $industryRank = parseInt(company.rank.industry),
        $link = '/companies/' + slugify(company.name);

    if ($sort) {
      function sort(x,y) {
        return y.scores[$issue][$component].overall - x.scores[$issue][$component].overall;
      }

      var $issue = $sort.split('.')[0],
          $component = $sort.split('.')[1],
          $industry = company.industry,
          $issuesData = '/wp-content/themes/justcapital/assets/data/methodology_metadata.json',
          $issueSort = stable($companies, sort),
          $issueRank = -1;

      $.getJSON($issuesData, function(data) {
        data.forEach(function(issue) {
          if (issue.website_id === $issue) {
            issue.components.forEach(function(component) {
              if (component.component === $component) $('.issue-name').text(component.shortname);
            });
          }
        });
      });

      // Company's overall rank for issue
      for (var i = 0; i < $issueSort.length; i++) {
        if ($issueSort[i].scores[$issue][$component].overall == company.scores[$issue][$component].overall) {
          $issueRank = i;
          break;
        }
      }
      $issueRank = $issueRank + 1;
      $ordinalRank = $issueRank + '<span>' + indicator($issueRank) + '</span>';

      // Company's rank in its industry for issue
      var $filtered = $issueSort.filter(function(companies) {
        return companies.industry === $industry;
      });
      var $issueIndustryRank = -1;
      for (var i = 0; i < $filtered.length; i++) {
        if ($filtered[i].scores[$issue][$component].overall == company.scores[$issue][$component].overall) {
          $issueIndustryRank = i;
          break;
        }
      }
      $industryRank = parseInt($issueIndustryRank + 1);
    }

    $el.find('.company-card__name').text(company.name);
    $el.find('.company-card__shortname').text(company.short_name);
    $el.find('.company-card__summary').text(company.description);

    $el.find('#rank').html($ordinalRank);
    $el.find('#industry-rank').html($industryRank + '<span>' + indicator($industryRank) + '</span>');

    $el.find('a').attr('href', $link);

    if ($el.hasClass('snapshot')) {
      $el.prev().attr('href', $link).text(company.name);
      if ($rank <= 100) $el.find('.company-card__info div').append('<p class="company-seal"><span></span></p>');
    }
  }
}

module.exports = CompanyCard;
